module.exports = __webpack_public_path__ + "img/03-2-3报表实施.5b27458e.svg";